import apiClient from "./ApiService";
import { PATH_PARAMETERS } from "../config/env";

export const getParametersConfig = async () => {
  return await apiClient.get(PATH_PARAMETERS);
};